var vintools = vintools || {}; vintools["app"] =
webpackJsonpvintools__name_([1],{

/***/ 134:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _blog = __webpack_require__(135);

var blog = _interopRequireWildcard(_blog);

var _checkout = __webpack_require__(136);

var checkout = _interopRequireWildcard(_checkout);

var _clubs = __webpack_require__(137);

var clubs = _interopRequireWildcard(_clubs);

var _general = __webpack_require__(65);

var general = _interopRequireWildcard(_general);

var _modalCart = __webpack_require__(138);

var modalCart = _interopRequireWildcard(_modalCart);

var _navigation = __webpack_require__(158);

var navigation = _interopRequireWildcard(_navigation);

var _newsletterPopup = __webpack_require__(160);

var newsletterPopup = _interopRequireWildcard(_newsletterPopup);

var _photoGallery = __webpack_require__(161);

var photoGallery = _interopRequireWildcard(_photoGallery);

var _products = __webpack_require__(162);

var products = _interopRequireWildcard(_products);

var _search = __webpack_require__(163);

var search = _interopRequireWildcard(_search);

var _userTools = __webpack_require__(164);

var userTools = _interopRequireWildcard(_userTools);

var _video = __webpack_require__(165);

var video = _interopRequireWildcard(_video);

var _v65Customizations = __webpack_require__(166);

var v65Customizations = _interopRequireWildcard(_v65Customizations);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var onLoadRecalculations = function onLoadRecalculations() {
  navigation.setHeaderOriginalOffset();
  navigation.scrollHeaderNav();
  checkout.init();
};

window.addEventListener('load', onLoadRecalculations, false);

// Resize functions
var resizeStart = new Date();
var timeout = false;
var delay = 200;

var resizeEnd = function resizeEnd() {
  if (new Date() - resizeStart < delay) {
    setTimeout(resizeEnd, delay);
  } else {
    // Add any scripts that need to trigger on end of window resize here
    timeout = false;
    navigation.setHeaderOriginalOffset();
    navigation.scrollHeaderNav();
    checkout.init();
  }
};

window.addEventListener('resize', function () {
  resizeStart = new Date();

  navigation.setHeaderOriginalOffset();
  navigation.scrollHeaderNav();
  navigation.scrollSecondaryNav();
  checkout.init();

  if (timeout === false) {
    timeout = true;
    setTimeout(resizeEnd, delay);
  }
}, false);

window.addEventListener('scroll', navigation.scrollHeaderNav, false);

userTools.init();
general.init();
v65Customizations.init();

blog.init();
checkout.init();
clubs.init();
modalCart.init();
navigation.init();
products.init();
search.init();
newsletterPopup.init();
photoGallery.init();
video.init();

/***/ }),

/***/ 135:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var init = exports.init = function init() {
  // eslint-disable-line import/prefer-default-export
  scrollBlogMeta();
};

var scrollBlogMeta = exports.scrollBlogMeta = function scrollBlogMeta() {
  var blogMeta = document.getElementsByClassName('blog-meta')[0];
  if (!blogMeta) {
    return false;
  }

  var blogMetaHeight = blogMeta.offsetHeight;
  if (window.innerHeight < blogMetaHeight) {
    blogMeta.classList.remove('blog-meta--sticky');
    return false;
  }

  blogMeta.classList.add('blog-meta--sticky');

  return blogMeta;
};

/***/ }),

/***/ 136:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var init = exports.init = function init() {
  checkoutSummaryCustomizations();
};

var checkoutSummaryCustomizations = exports.checkoutSummaryCustomizations = function checkoutSummaryCustomizations() {
  var checkoutSummary = document.getElementById('v65-checkoutCartSummaryWrapper');
  var clubSummary = document.getElementById('v65-signUpClubSummaryWrapper');

  if (!checkoutSummary && !clubSummary) {
    return false;
  }

  var currentSummary = checkoutSummary || clubSummary;
  currentSummary.classList.add('checkout-summary');

  if (window.innerWidth < 768 || window.innerHeight < currentSummary.offsetHeight + 95) {
    currentSummary.removeAttribute('style');
    currentSummary.classList.remove('checkout-summary--sticky');
    return currentSummary;
  }

  var checkoutFooterHeight = document.getElementById('v65-checkoutFooter').offsetHeight;
  currentSummary.style.marginBottom = checkoutFooterHeight + 'px';
  currentSummary.classList.add('checkout-summary--sticky');
  return currentSummary;
};

/***/ }),

/***/ 137:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var init = exports.init = function init() {
  // eslint-disable-line import/prefer-default-export
  wrapClubList();
};

var wrapClubList = function wrapClubList() {
  var clubs = [].concat(_toConsumableArray(document.getElementsByClassName('v65-club')));
  if (!clubs.length) {
    return false;
  }

  var clubList = document.createElement('div');
  clubList.className = 'club-list';
  clubs[0].parentElement.insertBefore(clubList, clubs[0]);
  clubs.forEach(function (club) {
    return clubList.appendChild(club);
  });
  return clubList;
};

/***/ }),

/***/ 138:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = undefined;

var _axios = __webpack_require__(50);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var _window = window,
    vin65 = _window.vin65;
var init = exports.init = function init() {
  // eslint-disable-line import/prefer-default-export
  var modalCart = document.getElementById('v65-modalCartDropdown');
  if (!modalCart) {
    return false;
  }

  prepareDefaultModalCart();
  addToCartSubmit();
  v65CustomCartResponse();
  v65CustomCartToggle();
  customizeModalCart();
  return modalCart;
};

var prepareDefaultModalCart = function prepareDefaultModalCart() {
  return document.body.classList.add('vt__modal-cart-enabled');
};

var addToCartSubmit = function addToCartSubmit() {
  var addToCartForms = [].concat(_toConsumableArray(document.querySelectorAll('[v65js=addToCart]')));
  if (!addToCartForms.length) {
    return false;
  }

  // Can't override Vin65 event without wrapping in DOMContentLoaded event
  return document.addEventListener('DOMContentLoaded', function () {
    addToCartForms.forEach(function (form) {
      return form.addEventListener('submit', handleAddToCartSubmit, false);
    });
  });
};

var customizeModalCart = function customizeModalCart() {
  var vtModalCart = document.getElementsByClassName('vt__modal-cart');
  if (!vtModalCart.length) {
    var modalCart = document.createElement('div');
    modalCart.className = 'vt__modal-cart';
    modalCart.innerHTML = '\n      <div class="vt__modal-cart__header">\n        <h4>Cart</h4>\n        <a href="#" class="vt__modal-cart__close"></a>\n      </div>\n      <div class="vt__modal-cart__carrot"></div>\n      <div class="vt__modal-cart__items"></div>\n      <div class="vt__modal-cart__checkout"></div>\n    ';
    document.body.appendChild(modalCart);
  }

  return getCartResponseJSON().then(function (cart) {
    formatModalCart(cart);
  }).catch(function (err) {
    console.error('err', err);
  });
};

var v65CustomCartResponse = function v65CustomCartResponse() {
  var v65CartResponse = vin65.cart.cartResponse;
  vin65.cart.cartResponse = function (response) {
    v65CartResponse(response);
    $('#v65-modalCartDropdown').stop(true, true).removeAttr('style'); // Stop jQuery animation from Vin65

    customizeModalCart().then(function () {
      showCart();
    });
  };
};

var v65CustomCartToggle = function v65CustomCartToggle() {
  vin65.cart.toggleCart = function () {
    document.getElementsByClassName('vt__modal-cart')[0].classList.toggle('vt__modal-cart--visible');
  };
};

var handleAddToCartSubmit = function handleAddToCartSubmit(event) {
  $('html, body').stop(); // Stop jQuery animation from Vin65
  var productSKU = event.target.children.productSKU.value;
  var cartProduct = document.querySelector('.vt__modal-cart__item[data-sku="' + productSKU + '"]');
  if (cartProduct) {
    cartProduct.classList.add('vt__modal-cart__item--updating');
  }
};

var getCartResponseJSON = function getCartResponseJSON() {
  var cartObject = {};
  var cartVersion = '';
  var v2Cart = window.hasCheckoutV2 === 1;
  if (v2Cart) {
    cartVersion = 'V2';
  }
  return _axios2.default.get('/index.cfm?method=cart' + cartVersion + '.showCart&overrideLayout=1&timestamp=' + new Date().getTime(), {
    responseType: 'text'
  }).then(function (res) {
    var html = new DOMParser().parseFromString(res.data, 'text/html');

    if (v2Cart) {
      return html.getElementsByClassName('v65-checkoutCart')[0];
    }

    return html.getElementById('v65-cartTable');
  }).then(function (cart) {
    var cartItems = [];
    var subtotal = 0;
    if (cart) {
      cartItems = [].concat(_toConsumableArray(cart.getElementsByClassName('v65-cartItem')));
      if (v2Cart) {
        subtotal = cart.getElementsByClassName('v65-subtotal')[0].getElementsByClassName('v65-value');
      } else {
        subtotal = cart.getElementsByClassName('v65-cartSubtotal-6');
      }
    }

    cartObject.items = cartItems.map(function (cartItem) {
      if (v2Cart) {
        return jsonCartItemV2(cartItem);
      }

      return jsonCartItem(cartItem);
    });

    cartObject.subtotal = subtotal.length && subtotal[0].innerText;
    return cartObject;
  }).catch(function (err) {
    console.error('err', err);
  });
};

var jsonCartItem = function jsonCartItem(cartItem) {
  var cartImage = cartItem.getElementsByClassName('v65-cartItemImage')[0];
  var cartDescription = cartItem.getElementsByClassName('v65-cartItemDescription')[0];
  var updateAmount = cartItem.getElementsByClassName('v65-cartItemAmount')[0];
  return {
    drilldownLink: cartImage.firstElementChild.getAttribute('href'),
    image: cartImage.getElementsByTagName('img')[0].getAttribute('src'),
    title: cartDescription.getElementsByTagName('strong')[0].innerText.trim(),
    price: cartItem.getElementsByClassName('v65-cartItemPrice')[0].innerText.trim(),
    total: cartItem.getElementsByClassName('v65-cartItemTotal')[0].innerText.trim(),
    quantity: parseInt(cartItem.getElementsByClassName('v65-qtyField')[0].value, 10),
    removeItem: cartItem.getElementsByClassName('v65-cartRemoveButton')[0].getAttribute('href'),
    updateQuantityAction: updateAmount.getElementsByTagName('form')[0].getAttribute('action'),
    sku: updateAmount.querySelector('input[name=productSKU]').value
  };
};

var jsonCartItemV2 = function jsonCartItemV2(cartItem) {
  var cartImage = cartItem.getElementsByClassName('v65-image')[0];
  return {
    drilldownLink: cartImage.getAttribute('href'),
    image: cartImage.getElementsByTagName('img')[0].getAttribute('src'),
    title: cartItem.getElementsByClassName('v65-itemTitle')[0].innerText.trim(),
    price: cartItem.getElementsByClassName('v65-price')[0].innerText.trim(),
    total: cartItem.getElementsByClassName('v65-totalPrice')[0].innerText.trim(),
    quantity: parseInt(cartItem.getElementsByClassName('v65-qtyField')[0].value, 10),
    removeItem: cartItem.getElementsByClassName('v65-removeItem')[0].getAttribute('href'),
    updateQuantityAction: cartItem.getElementsByTagName('form')[0].getAttribute('action'),
    sku: cartItem.getElementsByClassName('v65-itemTitle')[0].firstElementChild.dataset.sku
  };
};

var formatModalCart = function formatModalCart(cart) {
  _axios2.default.get('/index.cfm?method=cart.showModalCart').then(function (res) {
    var html = new DOMParser().parseFromString(res.data, 'text/html');
    var modalCartToggle = document.getElementById('v65-toggleModalCart');
    var newCartToggle = html.getElementById('v65-toggleModalCart');
    document.getElementById('v65-modalCart').replaceChild(newCartToggle, modalCartToggle);
    return html.getElementById('v65-modalCartDropdown');
  }).then(function (v65ModalCart) {
    var carrots = v65ModalCart.getElementsByClassName('v65-carrot');
    var vtCarrot = document.getElementsByClassName('vt__modal-cart__carrot')[0];
    if (carrots.length) {
      vtCarrot.innerHTML = carrots[0].outerHTML;
    } else {
      vtCarrot.innerHTML = '';
    }

    var vtCheckoutButton = document.getElementsByClassName('vt__modal-cart__checkout')[0];
    if (cart.items.length) {
      var checkoutLink = '/index.cfm?method=checkout.billing';
      if (window.hasCheckoutV2) {
        checkoutLink = '/index.cfm?method=checkoutV2.login';
      }

      vtCheckoutButton.innerHTML = '\n          <a href="' + checkoutLink + '" class="largeLinkBtn">\n            Checkout - ' + cart.subtotal + '\n          </a>\n        ';
    } else {
      vtCheckoutButton.innerHTML = '';
    }

    var modalCartItems = document.getElementsByClassName('vt__modal-cart__items')[0];
    modalCartItems.innerHTML = renderCartItems(cart.items).join('');

    updateItemQuantity();
    removeItemFromCart();
    closeModalCartEvent();
  }).catch(function (err) {
    console.error('err', err);
  });
};

var renderCartItems = function renderCartItems(items) {
  return items.map(function (item) {
    return '\n  <div class="vt__modal-cart__item" data-sku="' + item.sku + '">\n    <div class="vt__modal-cart__item__image">\n      <a href="' + item.drilldownLink + '">\n        <img src="' + item.image + '" alt="' + item.title + '" />\n      </a>\n    </div>\n\n    <div class="vt__modal-cart__item__details">\n      <a href="' + item.drilldownLink + '" class="vt__modal-cart__item__title">' + item.title + '</a>\n      <input\n        type="tel"\n        class="vt__modal-cart__item__quantity"\n        value="' + item.quantity + '"\n        data-sku="' + item.sku + '"\n        data-action="' + item.updateQuantityAction + '"\n      />\n      <span class="vt__modal-cart__item__price">x ' + item.price + '</span>\n      <a href="' + item.removeItem + '" class="vt__modal-cart__item__remove">Remove</a>\n    </div>\n\n    <div class="vt__modal-cart__item__total">' + item.total + '</div>\n  </div>\n';
  });
};

var updateItemQuantity = function updateItemQuantity() {
  var quantityInputs = [].concat(_toConsumableArray(document.getElementsByClassName('vt__modal-cart__item__quantity')));
  quantityInputs.forEach(function (quantityInput) {
    quantityInput.addEventListener('change', handleItemQuantityUpdate, false);
  });
};

var handleItemQuantityUpdate = function handleItemQuantityUpdate(event) {
  event.target.parentElement.parentElement.classList.add('vt__modal-cart__item--updating');
  var quantity = event.target.value;
  var productSKU = event.target.getAttribute('data-sku');
  var action = event.target.getAttribute('data-action');
  var formData = new FormData();
  formData.append('productSKU', productSKU);
  formData.append('quantity', quantity);
  _axios2.default.post(action, formData).then(function () {
    customizeModalCart();
  }).catch(function (err) {
    console.error('err', err);
  });
};

var removeItemFromCart = function removeItemFromCart() {
  var removeLinks = [].concat(_toConsumableArray(document.getElementsByClassName('vt__modal-cart__item__remove')));
  removeLinks.forEach(function (link) {
    ['touchstart', 'click'].forEach(function (event) {
      return link.addEventListener(event, handleRemoveItem, false);
    });
  });
};

var handleRemoveItem = function handleRemoveItem(event) {
  event.preventDefault();
  event.target.parentElement.parentElement.classList.add('vt__modal-cart__item--updating');
  _axios2.default.get(event.target.href).then(function () {
    customizeModalCart();
  });
};

var closeModalCartEvent = function closeModalCartEvent() {
  var closeModalCartButtons = [].concat(_toConsumableArray(document.getElementsByClassName('vt__modal-cart__close')));
  closeModalCartButtons.forEach(function (link) {
    ['touchstart', 'click'].forEach(function (event) {
      return link.addEventListener(event, handleHideCart, false);
    });
  });
};

var showCart = function showCart() {
  document.getElementsByClassName('vt__modal-cart')[0].classList.add('vt__modal-cart--visible');
};

var hideCart = function hideCart() {
  document.getElementsByClassName('vt__modal-cart')[0].classList.remove('vt__modal-cart--visible');
};

var handleHideCart = function handleHideCart(event) {
  event.preventDefault();
  hideCart();
};

/***/ }),

/***/ 158:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scrollSecondaryNav = exports.setHeaderOriginalOffset = exports.scrollHeaderNav = exports.init = undefined;

var _jump = __webpack_require__(159);

var _jump2 = _interopRequireDefault(_jump);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var init = exports.init = function init() {
  navHover();
  toggleMobileDropdown();
  toggleMobileNav();
  scrollToLink();
  setHeaderOriginalOffset();
  scrollHeaderNav();
  scrollSecondaryNav();
};

var navHover = function navHover() {
  var navLinks = [].concat(_toConsumableArray(document.querySelectorAll('nav li li a')));

  navLinks.forEach(function (navLink) {
    navLink.addEventListener('mouseover', function (event) {
      var topLink = event.target.parentElement.getElementsByTagName('a')[0];
      topLink.classList.add('hover');
    }, false);

    navLink.addEventListener('mouseout', function (event) {
      var topLink = event.target.parentElement.getElementsByTagName('a')[0];
      topLink.classList.remove('hover');
    }, false);
  });
};

var toggleMobileDropdown = function toggleMobileDropdown() {
  [].concat(_toConsumableArray(document.querySelectorAll('nav ul ul'))).map(function (subNav) {
    subNav.parentElement.classList.add('has-children');
    var input = document.createElement('input');
    input.type = 'checkbox';
    input.className = 'toggle-sub-menu';
    subNav.parentElement.insertBefore(input, subNav.parentElement.firstChild);
    return subNav;
  });
};

var toggleMobileNav = function toggleMobileNav() {
  var navToggle = document.getElementsByClassName('header__navigation__toggle')[0];
  ['touchstart', 'click'].forEach(function (event) {
    return navToggle.addEventListener(event, function (e) {
      e.preventDefault();
      document.body.classList.toggle('mobile-nav-active');
      var accountName = document.getElementsByClassName('account-name');
      if (accountName.length) {
        accountName[0].classList.remove('active');
      }
    }, false);
  });
};

var scrollHeaderNav = exports.scrollHeaderNav = function scrollHeaderNav() {
  if (window.innerWidth < 768) {
    return;
  }

  var headerNavigation = document.getElementsByClassName('header__navigation')[0];
  var isScrolling = headerNavigation.classList.contains('header__navigation--scrolling');
  var distance = headerNavigation.getAttribute('data-original-offset') - window.pageYOffset;

  if (distance <= 0 && !isScrolling) {
    headerNavigation.classList.add('header__navigation--scrolling');
  } else if (distance > 0 && isScrolling) {
    headerNavigation.classList.remove('header__navigation--scrolling');
  }
};

var setHeaderOriginalOffset = exports.setHeaderOriginalOffset = function setHeaderOriginalOffset() {
  var header = document.getElementsByTagName('header')[0];
  var headerNavigation = document.getElementsByClassName('header__navigation')[0];
  headerNavigation.classList.remove('header__navigation--scrolling');
  header.style.paddingBottom = headerNavigation.offsetHeight;
  headerNavigation.setAttribute('data-original-offset', headerNavigation.offsetTop);
};

var scrollToLink = function scrollToLink() {
  var scrollToLinks = [].concat(_toConsumableArray(document.querySelectorAll('a[href^="#"]')));

  scrollToLinks.forEach(function (link) {
    var id = link.getAttribute('href').split('#').filter(Boolean);
    if (id.length && document.getElementById(id[0])) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        var target = document.getElementById(id[0]);
        (0, _jump2.default)(target);
      }, false);
    }
  });
};

var scrollSecondaryNav = exports.scrollSecondaryNav = function scrollSecondaryNav() {
  var secondaryNav = document.getElementsByClassName('secondary-navigation')[0];
  if (!secondaryNav) {
    return false;
  }

  var secondaryNavHeight = secondaryNav.offsetHeight;
  if (window.innerHeight < secondaryNavHeight) {
    secondaryNav.classList.remove('secondary-navigation--sticky');
    return false;
  }

  secondaryNav.classList.add('secondary-navigation--sticky');

  return secondaryNav;
};

/***/ }),

/***/ 159:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
// Robert Penner's easeInOutQuad

// find the rest of his easing functions here: http://robertpenner.com/easing/
// find them exported for ES6 consumption here: https://github.com/jaxgeller/ez.js

var easeInOutQuad = function easeInOutQuad(t, b, c, d) {
  t /= d / 2;
  if (t < 1) return c / 2 * t * t + b;
  t--;
  return -c / 2 * (t * (t - 2) - 1) + b;
};

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var jumper = function jumper() {
  // private variable cache
  // no variables are created during a jump, preventing memory leaks

  var element = void 0; // element to scroll to                   (node)

  var start = void 0; // where scroll starts                    (px)
  var stop = void 0; // where scroll stops                     (px)

  var offset = void 0; // adjustment from the stop position      (px)
  var easing = void 0; // easing function                        (function)
  var a11y = void 0; // accessibility support flag             (boolean)

  var distance = void 0; // distance of scroll                     (px)
  var duration = void 0; // scroll duration                        (ms)

  var timeStart = void 0; // time scroll started                    (ms)
  var timeElapsed = void 0; // time spent scrolling thus far          (ms)

  var next = void 0; // next scroll position                   (px)

  var callback = void 0; // to call when done scrolling            (function)

  // scroll position helper

  function location() {
    return window.scrollY || window.pageYOffset;
  }

  // element offset helper

  function top(element) {
    return element.getBoundingClientRect().top + start;
  }

  // rAF loop helper

  function loop(timeCurrent) {
    // store time scroll started, if not started already
    if (!timeStart) {
      timeStart = timeCurrent;
    }

    // determine time spent scrolling so far
    timeElapsed = timeCurrent - timeStart;

    // calculate next scroll position
    next = easing(timeElapsed, start, distance, duration);

    // scroll to it
    window.scrollTo(0, next);

    // check progress
    timeElapsed < duration ? window.requestAnimationFrame(loop) // continue scroll loop
    : done(); // scrolling is done
  }

  // scroll finished helper

  function done() {
    // account for rAF time rounding inaccuracies
    window.scrollTo(0, start + distance);

    // if scrolling to an element, and accessibility is enabled
    if (element && a11y) {
      // add tabindex indicating programmatic focus
      element.setAttribute('tabindex', '-1');

      // focus the element
      element.focus();
    }

    // if it exists, fire the callback
    if (typeof callback === 'function') {
      callback();
    }

    // reset time for next jump
    timeStart = false;
  }

  // API

  function jump(target) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    // resolve options, or use defaults
    duration = options.duration || 1000;
    offset = options.offset || 0;
    callback = options.callback; // "undefined" is a suitable default, and won't be called
    easing = options.easing || easeInOutQuad;
    a11y = options.a11y || false;

    // cache starting position
    start = location();

    // resolve target
    switch (typeof target === 'undefined' ? 'undefined' : _typeof(target)) {
      // scroll from current position
      case 'number':
        element = undefined; // no element to scroll to
        a11y = false; // make sure accessibility is off
        stop = start + target;
        break;

      // scroll to element (node)
      // bounding rect is relative to the viewport
      case 'object':
        element = target;
        stop = top(element);
        break;

      // scroll to element (selector)
      // bounding rect is relative to the viewport
      case 'string':
        element = document.querySelector(target);
        stop = top(element);
        break;
    }

    // resolve scroll distance, accounting for offset
    distance = stop - start + offset;

    // resolve duration
    switch (_typeof(options.duration)) {
      // number in ms
      case 'number':
        duration = options.duration;
        break;

      // function passed the distance of the scroll
      case 'function':
        duration = options.duration(distance);
        break;
    }

    // start the loop
    window.requestAnimationFrame(loop);
  }

  // expose only the jump method
  return jump;
};

// export singleton

var singleton = jumper();

/* harmony default export */ __webpack_exports__["default"] = (singleton);


/***/ }),

/***/ 160:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = undefined;

var _jsCookie = __webpack_require__(66);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var init = exports.init = function init() {
  // eslint-disable-line import/prefer-default-export
  detectFormSuccess();
  dismissPopup();
  showPopup();
};

var detectFormSuccess = function detectFormSuccess() {
  var newsletterPopup = [].concat(_toConsumableArray(document.getElementsByClassName('newsletter-popup-wrapper')));
  if (!newsletterPopup.length || _jsCookie2.default.get('modalDismissed') === 'dismissed') {
    return false;
  }

  var formID = newsletterPopup[0].getElementsByClassName('v65-form')[0].id;
  if (localStorage['popupForm' + formID] !== undefined) {
    return false;
  }

  window.addEventListener('v65-formSubmission', function (event) {
    var formId = event.detail.id;
    var formResponse = event.detail.response;

    if (formResponse.includes('method="post"')) {
      localStorage['popupForm' + formId] = 'submitted';
    }

    $('html, body').stop(); // Stop jQuery animation from Vin65
  }, false);

  return newsletterPopup;
};

var dismissPopup = function dismissPopup() {
  var newsletterPopup = [].concat(_toConsumableArray(document.querySelectorAll('.newsletter-popup-wrapper .v65-pod')));
  if (!newsletterPopup.length) {
    return false;
  }

  var closeNewsletterPopup = document.createElement('div');
  closeNewsletterPopup.className = 'newsletter-popup-wrapper__close';
  newsletterPopup[0].appendChild(closeNewsletterPopup);

  ['touchstart', 'click'].forEach(function (event) {
    return closeNewsletterPopup.addEventListener(event, function (e) {
      e.preventDefault();
      newsletterPopup[0].parentElement.classList.remove('newsletter-popup-wrapper--visible');
      _jsCookie2.default.set('modalDismissed', 'dismissed', { expires: 7 });
    }, false);
  });

  return newsletterPopup;
};

var showPopup = function showPopup() {
  var newsletterPopup = [].concat(_toConsumableArray(document.getElementsByClassName('newsletter-popup-wrapper')));
  if (!newsletterPopup.length || _jsCookie2.default.get('modalDismissed') === 'dismissed') {
    return false;
  }

  var formID = newsletterPopup[0].getElementsByClassName('v65-form')[0].id;
  if (localStorage['popupForm' + formID] !== undefined) {
    return false;
  }

  setTimeout(function () {
    newsletterPopup[0].classList.add('newsletter-popup-wrapper--visible');
  }, 10000);

  return newsletterPopup[0];
};

/***/ }),

/***/ 161:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = undefined;

var _axios = __webpack_require__(50);

var _axios2 = _interopRequireDefault(_axios);

var _general = __webpack_require__(65);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var init = exports.init = function init() {
  // eslint-disable-line import/prefer-default-export
  initPhotoGallery();
};

var initPhotoGallery = function initPhotoGallery() {
  var photoGalleries = [].concat(_toConsumableArray(document.querySelectorAll('[v65jsphotogalleryid]')));
  if (photoGalleries.length) {
    (0, _general.loadJS)('https://template-cdn.vintools.co/canyon/assets/js/vendor/ideal-image-slider.min.js', function () {
      photoGalleries.map(function (gallery) {
        return vtScriptPhotoGallery(gallery);
      });
    });
  }
};

var vtScriptPhotoGallery = function vtScriptPhotoGallery(photoGallery, options) {
  // eslint-disable-line no-param-reassign
  var gallery = photoGallery;
  var defaults = {
    galleryId: gallery.getAttribute('v65jsphotogalleryid'),
    timestamp: '&timestamp=' + new Date().getTime(),
    height: 'auto',
    initialHeight: 400,
    maxHeight: null,
    interval: 4000,
    transitionDuration: 700,
    effect: 'slide',
    disableNav: false,
    keyboardNav: true
  };

  var settings = Object.assign({}, defaults, options);

  gallery.innerHTML = '';
  _axios2.default.get('/index.cfm?method=pages.showPhotoGalleryXML&photogalleryid=' + settings.galleryId + defaults.timestamp, {
    responseType: 'text'
  }).then(function (response) {
    var xml = new DOMParser().parseFromString(response.data, 'text/xml');
    return [].concat(_toConsumableArray(xml.getElementsByTagName('img')));
  }).then(function (images) {
    return images.map(function (image, index) {
      var basePath = '/assets/images/photogallery/images/large/';
      var imageSrc = basePath + image.getAttribute('src');
      var link = image.getAttribute('link');
      var alt = image.getAttribute('caption') || image.getAttribute('title');
      var src = '';

      if (index !== 0) {
        src = 'data-src="' + imageSrc + '" src=""';
      } else {
        src = 'src="' + imageSrc + '"';
      }

      if (link) {
        return '<a href="' + link + '"><img ' + src + ' alt="' + alt + '" /></a>';
      }
      return '<img ' + src + ' alt="' + alt + '" />';
    });
  }).then(function (galleryImages) {
    gallery.innerHTML = galleryImages.join('');

    var slider = new IdealImageSlider.Slider({ // eslint-disable-line no-new, no-undef, max-len
      selector: '[v65jsphotogalleryid="' + settings.galleryId + '"]',
      height: settings.height,
      initialHeight: settings.initialHeight,
      maxHeight: settings.maxHeight,
      interval: settings.interval,
      transitionDuration: settings.transitionDuration,
      effect: settings.effect,
      disableNav: settings.disableNav,
      keyboardNav: settings.keyboardNav
    });
    slider.addBulletNav();
    slider.start();
  }).catch(function () {
    gallery.innerHTML = '<p>Sorry, there was an error loading the gallery</p>';
  });
};

/***/ }),

/***/ 162:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var init = exports.init = function init() {
  // eslint-disable-line import/prefer-default-export
  setProductGroupAnchors();
  wrapProductList();
  wrapTitleVintage();
};

var setProductGroupAnchors = function setProductGroupAnchors() {
  var productGroupTitles = [].concat(_toConsumableArray(document.getElementsByClassName('v65-productGroup-title')));
  productGroupTitles.forEach(function (productGroupTitle) {
    productGroupTitle.setAttribute('id', productGroupTitle.textContent.replace(/[^a-zA-Z0-9-_]/g, '-').toLowerCase());
  });
};

var wrapProductList = function wrapProductList() {
  var products = [].concat(_toConsumableArray(document.querySelectorAll('.v65-product2Up, .v65-product3Up, .v65-product5Up')));
  if (!products.length) {
    return false;
  }

  var productList = document.createElement('div');
  productList.className = 'product-list';
  products[0].parentElement.insertBefore(productList, products[0]);
  products.forEach(function (product) {
    return productList.appendChild(product);
  });
  return productList;
};

var wrapTitleVintage = function wrapTitleVintage() {
  var productTitles = [].concat(_toConsumableArray(document.getElementsByClassName('v65-product-title')));
  productTitles.forEach(function (productTitle) {
    var link = productTitle.children[0];
    var productText = productTitle.textContent;
    var vintageRegex = /(\d{4}|N\/?V)/;
    var vintage = vintageRegex.exec(productText);

    if (vintage) {
      var title = productText.split(vintage[0]).filter(Boolean).join('').trim();
      link.innerHTML = '\n        <span class="product-vintage">' + vintage[0] + '</span>\n        <span class="product-title">' + title + '</span>\n      ';
    }
  });
};

/***/ }),

/***/ 163:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = undefined;

var _axios = __webpack_require__(50);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var init = exports.init = function init() {
  // eslint-disable-line import/prefer-default-export
  loadSearchResults();
  loadPaginationResults();
  setSearchFormAttributes();
  toggleSearchVisibility();
};

var setSearchFormAttributes = function setSearchFormAttributes() {
  var searchInput = document.querySelector('.search input[name="searchText"]');
  searchInput.setAttribute('placeholder', 'Search');
  searchInput.setAttribute('autocomplete', 'off');
};

var loadSearchResults = function loadSearchResults() {
  var searchForm = document.getElementsByClassName('search__wrapper')[0].getElementsByTagName('form')[0];
  searchForm.addEventListener('submit', handleSearchSubmit, false);
};

var handleSearchSubmit = function handleSearchSubmit(event) {
  event.preventDefault();
  var searchResults = document.getElementsByClassName('search__results')[0];
  var form = event.target;
  var formValues = [].concat(_toConsumableArray(form.getElementsByTagName('input'))).map(function (input) {
    return input.name + '=' + encodeURIComponent(input.value);
  }).join('&');

  searchResults.innerHTML = '<img src="/assets/images/icon-loading.svg">';

  _axios2.default.get('/index.cfm?' + formValues + '&overrideLayout=1').then(function (response) {
    searchResults.innerHTML = response.data;
  }).catch(function (err) {
    searchResults.innerHTML = err.data;
  });
};

var loadPaginationResults = function loadPaginationResults() {
  var paginationLinks = [].concat(_toConsumableArray(document.querySelectorAll('.searchPagination a')));
  paginationLinks.forEach(function (paginationLink) {
    ['touchstart', 'click'].forEach(function (event) {
      return paginationLink.addEventListener(event, handlePagination, false);
    });
  });
};

var handlePagination = function handlePagination(event) {
  event.preventDefault();
  var searchResults = document.getElementsByClassName('search__results')[0];
  var href = event.target.getAttribute('href');

  searchResults.innerHTML = '<img src="/assets/images/icon-loading.svg">';

  _axios2.default.get(href + '&overrideLayout=1').then(function (response) {
    searchResults.innerHTML = response.data;
  }).catch(function (err) {
    searchResults.innerHTML = err.data;
  });
};

var toggleSearchVisibility = function toggleSearchVisibility() {
  var searchToggles = [].concat(_toConsumableArray(document.getElementsByClassName('search__toggle')));
  var searchOverlay = document.getElementsByClassName('search')[0];
  searchToggles.forEach(function (searchToggle) {
    ['touchstart', 'click'].forEach(function (event) {
      return searchToggle.addEventListener(event, function (e) {
        e.preventDefault();
        searchOverlay.classList.toggle('search--is-visible');
      }, false);
    });
  });
};

/***/ }),

/***/ 164:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var init = exports.init = function init() {
  // eslint-disable-line import/prefer-default-export
  setAccountLink();
};

var setAccountLink = function setAccountLink() {
  var loginLink = document.getElementsByClassName('v65-login')[0];
  var usernameLink = document.getElementsByClassName('v65-editProfile')[0];
  var accountName = document.getElementsByClassName('account-name')[0];

  if (loginLink) {
    accountName.parentElement.replaceChild(loginLink.children[0], accountName);
  }

  if (usernameLink) {
    var username = usernameLink.textContent.split('Hello ')[1];
    accountName.textContent = username;
  }
};

/***/ }),

/***/ 165:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = undefined;

var _general = __webpack_require__(65);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var init = exports.init = function init() {
  // eslint-disable-line import/prefer-default-export
  loadVideoAPI();
  setupVideos();
};

var loadVideoAPI = function loadVideoAPI() {
  var vimeoVideos = [].concat(_toConsumableArray(document.querySelectorAll('[data-video="Vimeo"]')));
  var youtubeVideos = [].concat(_toConsumableArray(document.querySelectorAll('[data-video="YouTube"]')));

  if (vimeoVideos.length) {
    (0, _general.loadJS)('https://player.vimeo.com/api/player.js');
  }

  if (youtubeVideos.length) {
    (0, _general.loadJS)('https://www.youtube.com/iframe_api');
  }
};

var setupVideos = function setupVideos() {
  var videos = [].concat(_toConsumableArray(document.querySelectorAll('[data-video="Vimeo"],[data-video="YouTube"]')));

  videos.forEach(function (video) {
    var videoId = video.dataset.videoId;
    var videoProvider = video.dataset.video.toLowerCase();

    var playButton = document.createElement('div');
    playButton.className = 'vt__play-video';
    playButton.setAttribute('data-video', videoProvider);
    playButton.setAttribute('data-video-id', videoId);

    var modalVideo = document.createElement('div');
    modalVideo.className = 'vt__modal-video';
    modalVideo.innerHTML = '\n      <div class="vt__modal-video__wrapper">\n        <div class="vt__modal-video__video">\n          <div id="' + videoProvider + '-' + videoId + '"></div>\n        </div>\n        <div class="vt__modal-video__close" data-video="' + videoProvider + '" data-video-id="' + videoId + '"></div>\n      </div>\n    ';

    video.appendChild(playButton);
    document.body.appendChild(modalVideo);
  });

  addPlayButtonEvents();
  addCloseModalEvents();
};

var addPlayButtonEvents = function addPlayButtonEvents() {
  var playButtons = [].concat(_toConsumableArray(document.getElementsByClassName('vt__play-video')));
  playButtons.forEach(function (button) {
    ['touchstart', 'click'].forEach(function (event) {
      return button.addEventListener(event, handlePlayVideo, false);
    });
  });
};

var handlePlayVideo = function handlePlayVideo(event) {
  var videoProvider = event.target.dataset.video.toLowerCase();
  var videoId = event.target.dataset.videoId;

  switch (videoProvider) {
    case 'vimeo':
      triggerVimeoVideo(videoId);
      break;
    case 'youtube':
      triggerYoutubeVideo(videoId);
      break;
    default:
      break;
  }

  var modalVideo = document.getElementById(videoProvider + '-' + videoId);
  modalVideo.parentElement.parentElement.parentElement.classList.add('vt__modal-video--visible');
};

var addCloseModalEvents = function addCloseModalEvents() {
  var closeModalVideoButtons = [].concat(_toConsumableArray(document.getElementsByClassName('vt__modal-video__close')));
  closeModalVideoButtons.forEach(function (button) {
    ['touchstart', 'click'].forEach(function (event) {
      return button.addEventListener(event, handleCloseVideo, false);
    });
  });
};

var handleCloseVideo = function handleCloseVideo(event) {
  var videoProvider = event.target.dataset.video.toLowerCase();
  var videoId = event.target.dataset.videoId;
  var player = window[videoProvider + 'Videos'][videoId];

  switch (videoProvider) {
    case 'vimeo':
      player.pause();
      break;
    case 'youtube':
      player.pauseVideo();
      break;
    default:
      break;
  }

  event.target.parentElement.parentElement.classList.remove('vt__modal-video--visible');
};

var triggerYoutubeVideo = function triggerYoutubeVideo(videoId) {
  var youtubeVideos = window.youtubeVideos || {};
  if (youtubeVideos && youtubeVideos[videoId]) {
    youtubeVideos[videoId].playVideo();
    return youtubeVideos[videoId];
  }

  var player = new window.YT.Player('youtube-' + videoId, {
    videoId: videoId,
    width: 1280,
    height: 720,
    playerVars: {
      cc_load_policy: 0,
      showinfo: 0,
      modestbranding: 1,
      iv_load_policy: 3,
      autoplay: 1,
      rel: 0
    }
  });

  player.addEventListener('onReady', function () {
    player.playVideo();
  });

  youtubeVideos[videoId] = player;
  window.youtubeVideos = youtubeVideos;

  return player;
};

var triggerVimeoVideo = function triggerVimeoVideo(videoId) {
  var vimeoVideos = window.vimeoVideos || {};
  if (vimeoVideos && vimeoVideos[videoId]) {
    vimeoVideos[videoId].play();
    return vimeoVideos[videoId];
  }

  var options = {
    id: videoId,
    width: 1280
  };

  var player = new window.Vimeo.Player('vimeo-' + videoId, options);
  player.play();
  vimeoVideos[videoId] = player;
  window.vimeoVideos = vimeoVideos;

  return player;
  // player.pause();
};

/***/ }),

/***/ 166:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var vin65 = window.vin65;

var init = exports.init = function init() {
  // eslint-disable-line import/prefer-default-export
  setLoadingGraphic();
  handleFormSubmissions();
  customReloadBillingElements();
};

var setLoadingGraphic = function setLoadingGraphic() {
  vin65.modal.loadingGraphic = "<img src='/assets/images/icon-loading.svg'>";
};

var handleFormSubmissions = function handleFormSubmissions() {
  var v65FormResponse = vin65.form.formResponse;
  vin65.form.formResponse = function (response, formDiv) {
    v65FormResponse(response, formDiv);
    var event = new CustomEvent('v65-formSubmission', { detail: {
        id: formDiv,
        response: response
      } });
    window.dispatchEvent(event);
  };
};

var customReloadBillingElements = function customReloadBillingElements() {
  var v65ReloadBillingElements = vin65.checkout.reloadBillingElements;
  vin65.checkout.reloadBillingElements = function () {
    v65ReloadBillingElements();
    var event = new CustomEvent('v65-reloadBillingElements');
    window.dispatchEvent(event);
  };
};

/***/ }),

/***/ 65:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadJS = exports.init = undefined;

var _jsCookie = __webpack_require__(66);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var vin65 = window.vin65;

var init = exports.init = function init() {
  // eslint-disable-line import/prefer-default-export
  eventPolyfill();
  addButtonListener();
  addToCartListener();
  addCacheIFrame();
  closeModal();
  continueShopping();
  hideOptInCheckbox();
  hideOptInCheckboxOnError();
  removeEmptyTags();
  removeFieldsets();
  setInputTypes();
  checkoutToggleShipping();
};

var addButtonListener = function addButtonListener() {
  document.addEventListener('touchstart', function () {}, true);
};

var addToCartListener = function addToCartListener() {
  [].concat(_toConsumableArray(document.querySelectorAll('[v65js="addToCart"]'))).forEach(function (form) {
    form.addEventListener('submit', function () {
      _jsCookie2.default.set('continueShoppingURL', window.location.href);
    }, false);
  });
};

var addCacheIFrame = function addCacheIFrame() {
  var cache = document.createElement('iframe');
  cache.src = '/cache.html';
  cache.style.cssText = 'width:0;height:0;border:0;display:none';
  document.body.appendChild(cache);
};

var continueShopping = function continueShopping() {
  var continueShoppingURL = _jsCookie2.default.get('continueShoppingURL');

  if (continueShoppingURL !== null) {
    var checkoutLinks = [].concat(_toConsumableArray(document.querySelectorAll('#v65-checkCartSummaryMoreOptions a')));
    checkoutLinks.forEach(function (checkoutLink) {
      if (checkoutLink.textContent === 'Continue shopping') {
        checkoutLink.setAttribute('href', continueShoppingURL);
      }
    });

    var cartLinks = [].concat(_toConsumableArray(document.querySelectorAll('.v65-cartCheckOutButtons .linkAltBtn')));
    cartLinks.forEach(function (cartLink) {
      cartLink.setAttribute('href', continueShoppingURL);
    });
  }
};

var hideOptInCheckbox = function hideOptInCheckbox() {
  var optInCheckboxes = [].concat(_toConsumableArray(document.querySelectorAll('.newsletter-popup-wrapper div > input[name="isSingleOptIn"]')));
  optInCheckboxes.forEach(function (checkbox) {
    checkbox.checked = true; // eslint-disable-line no-param-reassign
    checkbox.parentElement.style.display = 'none'; // eslint-disable-line no-param-reassign
  });
};

var hideOptInCheckboxOnError = function hideOptInCheckboxOnError() {
  window.addEventListener('v65-formSubmission', hideOptInCheckbox, false);
};

var removeEmptyTags = function removeEmptyTags() {
  var elements = [].concat(_toConsumableArray(document.getElementsByTagName('p')));
  var productHeader = document.querySelector('.product-header h2');
  if (productHeader) {
    elements.push(productHeader);
  }

  elements.forEach(function (el) {
    if (el.innerHTML.replace(/\s|&nbsp;|<!--.*-->/g, '').length === 0) {
      el.parentElement.removeChild(el);
    }
  });
};

var closeModal = function closeModal() {
  window.addEventListener('click', function (e) {
    if (e.target.id === 'v65-modalViel') {
      vin65.modal.closeWindow();
    }
  }, false);
};

var removeFieldsets = function removeFieldsets() {
  var fieldsets = [].concat(_toConsumableArray(document.getElementsByTagName('fieldset')));
  fieldsets.forEach(function (fieldset) {
    var parent = fieldset.parentElement;
    switch (true) {
      case parent.id === 'v65-checkBilling':
      case parent.parentElement.id === 'v65-checkBilling':
      case parent.parentElement.id === 'v65-memberFormWrapper':
        return false;
      default:
        break;
    }

    while (fieldset.firstChild) {
      fieldset.parentElement.insertBefore(fieldset.firstChild, fieldset);
    }
    fieldset.parentElement.removeChild(fieldset);
    return fieldset;
  });
};

var setInputTypes = function setInputTypes() {
  var inputs = [].concat(_toConsumableArray(document.getElementsByTagName('input')));
  inputs.forEach(function (input) {
    var inputName = input.name.toLowerCase();
    switch (true) {
      case inputName.includes('email'):
        input.setAttribute('type', 'email');
        break;
      case inputName.includes('phone'):
      case inputName.includes('cardnumber'):
      case inputName.includes('quantity'):
        input.setAttribute('type', 'tel');
        break;
      default:
        return false;
    }

    return input;
  });
};

var checkoutToggleShipping = function checkoutToggleShipping() {
  return window.addEventListener('v65-reloadBillingElements', setInputTypes, false);
};

var eventPolyfill = function eventPolyfill() {
  if (typeof window.CustomEvent === 'function') {
    return false;
  }

  function CustomEvent(event, params) {
    var eventParams = params || { bubbles: false, cancelable: false, detail: undefined };
    var evt = document.createEvent('CustomEvent');
    evt.initCustomEvent(event, eventParams.bubbles, eventParams.cancelable, eventParams.detail);
    return evt;
  }

  CustomEvent.prototype = window.Event.prototype;

  window.CustomEvent = CustomEvent;
  return CustomEvent;
};

var loadJS = exports.loadJS = function loadJS(src, cb) {
  var ref = window.document.getElementsByTagName('script')[0];
  var script = window.document.createElement('script');
  script.src = src;
  script.async = true;
  ref.parentNode.insertBefore(script, ref);
  if (cb && typeof cb === 'function') {
    script.onload = cb;
  }
  return script;
};

/***/ })

},[134]);


// WEBPACK FOOTER //
// app.min.js